import { SocketProvider } from "./SocketContext";

export const SocketWrapper = ({ children }: any) => {
  return (
    <SocketProvider>
      {children}
    </SocketProvider>
  );
};
